(function () {
	'use strict';

	angular.module('gatewayApp').controller('ForexConfigurationsDialogController',
		ForexConfigurationsDialogController);

	ForexConfigurationsDialogController.$inject = ['$scope', '$state', '$rootScope',
		'GlobalValues', 'workflowSharedService', '$uibModalInstance',
		'ForexConfigurations', 'entity', 'DateUtils', 'AlertService', '$filter', 'StaticLookUp'];

	function ForexConfigurationsDialogController($scope, $state, $rootScope, GlobalValues,
		workflowSharedService, $uibModalInstance, ForexConfigurations, entity, DateUtils, AlertService, $filter, StaticLookUp) {
		var vm = this;
		vm.homeBranch = entity;
		vm.forexConfigurationsDTO = {};
		vm.numberOfDigits = 11;
		vm.ExpandOrCollapseRedirectionURLConfigurations = false;
		vm.ExpandOrCollapseFeeConfigurations = false;
		vm.clear = clear;
		vm.save = save;
		vm.clicked = false;
		$scope.showButton = false;
		vm.resubmitForexConfigurations = resubmitForexConfigurations;
		vm.globalValues = GlobalValues;
		vm.todayDate = new Date();
		vm.disablemode = false;

		vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
		vm.unitTypes = [
				{ value: 'Fixed', displayName: 'Fixed ' },
				{ value: 'Percentage', displayName: 'Percentage' }
		];

		vm.currencyNotesDeliveryOptions = [
				{ name: 'AVAILABLE', value: 'AVAILABLE' },
				{ name: 'NOT_AVAILABLE', value: 'NOT_AVAILABLE' },
				{ name: 'INAPP', value: 'INAPP' },
				{ name: 'REDIRECTION', value: 'REDIRECTION' }
		];
		vm.deliveryConfigOptions = [
				{ name: 'AVAILABLE', value: 'AVAILABLE' },
				{ name: 'NOT_AVAILABLE', value: 'NOT_AVAILABLE' },
				{ name: 'INAPP', value: 'INAPP' },
				{ name: 'REDIRECTION', value: 'REDIRECTION' }
		];


		if (workflowSharedService.viewFrom == 'forexConfigurations') {
			vm.forexConfigurations = entity;
			if (!vm.forexConfigurations.bankForexFeeDetailsList) {
				vm.forexConfigurations.bankForexFeeDetailsList = [];
			}
			// Normalize values correctly
			vm.forexConfigurations.bankForexFeeDetailsList.forEach(function (fee) {
				if (fee.units) {
					if (fee.units == 'Fixed') {
						fee.units = vm.unitTypes[0];
					}
					else {
						fee.units = vm.unitTypes[1];
					}

				}
			});
			$scope.showButton = false;
		} else if (workflowSharedService.viewFrom == 'forex_configurationstodolist_resubmit') {
			vm.forexConfigurationsDTO = angular.fromJson($rootScope.payload);
			if (vm.forexConfigurations == undefined) {
				vm.forexConfigurations = vm.forexConfigurationsDTO
			}
			// Normalize values correctly
			vm.forexConfigurations.bankForexFeeDetailsList.forEach(function (fee) {
				if (fee.units) {
					if (fee.units == 'Fixed') {
						fee.units = vm.unitTypes[0];
					}
					else {
						fee.units = vm.unitTypes[1];
					}

				}
			});

			vm.disableForm = false;
			vm.disablemode = true;
			$scope.showButton = true;
		}


		function clear() {
			$uibModalInstance.dismiss('cancel');
		}
		function save() {
			vm.forexConfigurationsDTO = vm.forexConfigurations;
			vm.forexConfigurationsDTO.bankForexFeeDetailsList.forEach(function (fee) {
				if (fee.units && typeof fee.units === 'object') {
					fee.units = fee.units.value; // <-- convert object to string
				}
				fee.bank=vm.forexConfigurations.bank;
			});
			if(vm.forexConfigurationsDTO.bankForexUrlDetails != null && vm.forexConfigurationsDTO.bankForexUrlDetails != undefined){
			vm.forexConfigurationsDTO.bankForexUrlDetails.bank =vm.forexConfigurations.bank;
			}
			ForexConfigurations.update({
				"corpId": GlobalValues.getCorpId()
			}, vm.forexConfigurationsDTO, onSaveSuccess, onSaveError);
		}

		function onSaveSuccess(result) {
			$uibModalInstance.close(result);
			vm.clicked = false;
		}

		function onSaveError() {
			vm.clicked = false;
		}



		function resubmitForexConfigurations() {
			vm.forexConfigurationsDTO = vm.forexConfigurations;
			vm.forexConfigurationsDTO.bankForexFeeDetailsList.forEach(function (fee) {
				if (fee.units && typeof fee.units === 'object') {
					fee.units = fee.units.value; // <-- convert object to string
				}
			});
			ForexConfigurations.resubmitForCreate({
				"taskId": $rootScope.taskID
			}, vm.forexConfigurationsDTO, onResubmitSuccess, onResubmitError);
		}

		function onResubmitSuccess(result) {
			$rootScope.removeRow($rootScope.taskID);
			$uibModalInstance.dismiss('cancel');
		}
		function onResubmitError(error) {
			vm.clicked = false;
		}

	}
})();
